"use strict";

import { modal } from "../../modules/_modal";

window.addEventListener("DOMContentLoaded", () => {
  modal();
});
